(function () {
  function updateHeaderCartCount() {
    var countEls = document.querySelectorAll('[data-header-cart-count]');
    if (!countEls.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count === 'undefined') return;
        countEls.forEach(function (el) {
          el.textContent = String(cart.item_count || 0);
        });
      })
      .catch(function () {
        countEls.forEach(function (el) {
          if (el.textContent.trim().toLowerCase() === 'undefined') {
            el.textContent = '0';
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', updateHeaderCartCount);
  window.addEventListener('pageshow', updateHeaderCartCount);
  setTimeout(updateHeaderCartCount, 1200);
  setTimeout(updateHeaderCartCount, 3000);
})();
